/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 12/14/20
 * Copyright All Rights Reserved
 */
// @flow
import React, { useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import EditOrganizationForm from './EditOrganizationForm';

import type { Organization } from 'types/Organization';

type Props = {
  fetchOrg: Function,
  organization: Organization,
};

const EditOrganization = ({ fetchOrg, organization }: Props) => {
  useEffect(() => {
    if (!organization) {
      fetchOrg();
    }
  }, [organization]);

  if (!organization) return null;

  return (
    <div>
      <Row>
        <Col md="12">
          <h1>Edit Organization</h1>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <EditOrganizationForm organization={organization} />
        </Col>
      </Row>
    </div>
  );
};

export default EditOrganization;



// WEBPACK FOOTER //
// ./js/components/pages/Admin/sections/Organizations/EditOrganization/EditOrganization.jsx